
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import paginacion from './lista-listado-paginacion.vue';
    import item from './lista-listado-item.vue';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion,
            item,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        public Seleccionado: Pregunta = null;
        Seleccionar( x: Pregunta )
        {
            this.Seleccionado = x;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.Buscador.onActualizar.subscribe( () =>
            {
                if ( this.Buscador.Items.hasRows() && !this.Buscador.Items[0].Respuesta )
                    this.$nextTick( () => this.Controlador.SiguientePregunta() );

            } ) );

            //Seleccionar(x)
        }

        public get Headers(): Array<DataTableHeader>
        {

            return [
                { text: '', align: 'center', value: 'Imagen', width: '65px' },
                { text: 'Pregunta', align: 'start', value: 'Col1', },
                { text: 'Fecha', align: 'start', value: 'Col2' },
                //{ text: '', align: 'end', value: 'Col8' },
            ];

        }

        public CargandoMenu: boolean = false;



    }
